(function () {
  function initReveal(root = document) {
    const els = Array.from(root.querySelectorAll('[data-reveal]'));
    if (!('IntersectionObserver' in window) || !els.length) {
      // fallback simples
      els.forEach(el => el.classList.add('in-view'));
      return;
    }

    const show = (el, obs) => {
      el.classList.add('in-view');
      // Para reanimar sempre que sair/entrar, comente a linha abaixo:
      if (obs) obs.unobserve(el);
    };

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) show(entry.target, obs);
      });
    }, {
      // threshold 0: basta um pixel entrar. Com fração (ex.: 0.15) uma seção
      // mais alta que a viewport pode nunca atingir a razão exigida e ficar
      // invisível para sempre — foi o que aconteceu com a seção de produto.
      rootMargin: '0px 0px -5% 0px',
      threshold: 0
    });

    els.forEach(el => {
      // Já está na tela ou acima dela (âncora, restauração de scroll, rolagem
      // muito rápida)? Mostra direto, sem esperar o observer.
      if (el.getBoundingClientRect().top < window.innerHeight) show(el, null);
      else io.observe(el);
    });

    // Rede de segurança: se algo escapar de tudo acima, o conteúdo aparece.
    // Perder a animação é aceitável; perder o conteúdo, não.
    setTimeout(() => els.forEach(el => el.classList.add('in-view')), 4000);
  }

  // inicializa no carregamento normal
  document.addEventListener('DOMContentLoaded', () => initReveal(document));

  // re-inicializa ao inserir/editar sections no Theme Editor
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
  document.addEventListener('shopify:section:select', (e) => initReveal(e.target));
})();
